import React from 'react';
import {
    faCheckCircle,
    faObjectGroup,
} from '@fortawesome/free-solid-svg-icons';
import { FormGroup, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import { BaseFormViewModel } from '../common/ViewModel';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import {
    FormLabel,
    onFieldChange,
    ToastMessage,
} from '../common/forms/FormElements';
import CommonContext from '../Common';
import { ApiRoutes } from '../ApiRoutes';
import SlideForm from '../common/forms/SlideForm';
import { util } from '../Util';
import { handleFormSaveError } from '../common/forms/ValidationError';

export class EquipmentGroupForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();

        const stateBase = {
            equipmentGroup: {},
            show: false,
            formValidated: false,
            ...new BaseFormViewModel(),
        };

        this.state = stateBase;
        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);

        this.onEquipmentTypeIdsChange =
            this.onEquipmentTypeIdsChange.bind(this);
    }

    componentDidMount() {
        this.populateState();
    }

    onChange = onFieldChange.bind(this);

    onClose(response) {
        this.setState({ show: false });
        this.resetForm();
        this.context.setFormOpened(false);
        this.props.onClose(response);
    }

    onEquipmentTypeIdsChange = (equipmentTypes) => {
        const equipmentTypeIds = equipmentTypes.map((et) => et.id);

        const { equipmentGroup } = this.state;
        equipmentGroup.equipmentTypeIds = equipmentTypeIds;

        this.setState({ equipmentGroup });
    };

    onSubmit = async () => {
        const { equipmentGroup } = this.state;

        this.setState({ errors: {}, saving: true });

        const response = await util.fetch.andGetResponse(
            util.fetch.types.put,
            ApiRoutes.equipmentGroup.update(),
            equipmentGroup
        );

        if (response) {
            const { onSaveCallback } = this.props;

            toast.success(
                <ToastMessage
                    icon={faCheckCircle}
                    header="Save Successful"
                    message={`Equipment Group [${equipmentGroup.name}] saved.`}
                />
            );
            this.setState({ show: false, saving: false });
            this.resetForm();
            onSaveCallback();
        }
    };

    handleSaveError = handleFormSaveError.bind(this);

    open = async (id) => {
        this.resetForm();
        this.setState({ show: true, loading: true });
        this.context.setFormOpened(true);

        const [equipmentGroup] = await Promise.all([
            util.fetch.js(ApiRoutes.equipmentGroup.byId(id)),
        ]);

        this.setState({
            equipmentGroup,
            loading: false,
        });
    };

    async populateState() {}

    resetForm() {
        this.setState({ formValidated: false, equipmentGroup: {} });
    }

    render() {
        const {
            loading,
            show,
            equipmentGroup,
            formValidated,
            validationMessage,
            errors,
        } = this.state;

        const { equipmentTypes } = this.props;

        return (
            <SlideForm
                loading={loading}
                show={show}
                id="equipmentGroupForm"
                formIcon={faObjectGroup}
                formTitle="Edit Equipment Group"
                ref={this.formRef}
                setIsValidated={(value) => {
                    this.setState({ formValidated: value });
                }}
                isValidated={formValidated}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                onSave={this.onSave}
                onDelete={this.onDelete}
                errors={errors}
                onClearErrors={this.onClearErrors}
                validationMessage={validationMessage}
            >
                <FormGroup>
                    <FormLabel htmlFor="name" text="Name" />
                    <Input
                        id="description"
                        name="equipmentGroup.name"
                        value={equipmentGroup.name}
                        type="text"
                        readOnly={true}
                    />
                </FormGroup>

                <FormGroup>
                    <FormLabel
                        id="equipmentTypeLabel"
                        htmlFor="equipmentGroup.equipmentTypeIds"
                        text="Equipment Types"
                        helpMessage="Select any equipment types that are represented by this equipment group."
                    />
                    <ValidatedSelect
                        id="equipmentGroup.equipmentTypeIds"
                        name="equipmentGroup.equipmentTypeIds"
                        isMulti
                        options={equipmentTypes}
                        value={
                            (equipmentTypes ?? []).filter((et) =>
                                (
                                    equipmentGroup.equipmentTypeIds ?? []
                                ).includes(et.id)
                            ) ?? ''
                        }
                        onChange={this.onEquipmentTypeIdsChange}
                        getOptionLabel={(et) => et.description}
                        getOptionValue={(et) => et.id}
                    />
                </FormGroup>
            </SlideForm>
        );
    }
}
